import { httpClient } from '@/lib/http-client'

export const authApi = {
    loginWithAzureAD: (azure_ad_token: string) =>
        httpClient.post('/auth/login', { azure_ad_token }),
    logout: () => httpClient.post('/auth/logout'),
    verify: () => httpClient.get('/auth/verify'),
    profile: () => httpClient.get('/auth/profile'),
    updateProfile: (data: any) => httpClient.put('/auth/profile', data),
    refresh: () => httpClient.post('/auth/refresh'),
    sessionStatus: () => httpClient.get('/auth/session-status'),
}
